
export default function Navigation() {

	let container,
		wrapper,
		dropdowns,
		toggled = false,
		toggle, menu,
		addSenceAds,
		headerLogo,
		addsenceCheckTimer;

	container = document.getElementById('site-navigation');
	wrapper = document.querySelector('.allWrapper');

	if ( ! container ) {
		return;
	}



	toggle = container.querySelector('.menuToggle');
	menu= container.querySelector('.menu');
  	headerLogo = document.querySelector('.header-logo');

	toggle.addEventListener('click', (e)=>{
		if (!window.matchMedia("(min-width: 992px)").matches) {
			toggled = !toggled;
			container.classList.toggle('toggled');
			wrapper.classList.toggle('allWrapper_slideout');
		}
	});

	if(window.location.hash){
		
	}

	

	addsenceCheckTimer = setInterval(
		()=>{



			let topAdIsVisible = false;
			addSenceAds = [ ... document.querySelectorAll('.adsbygoogle-noablate')];
			addSenceAds.forEach((ad)=>{
				if(
					ad.style.position == 'fixed' &&
					ad.style.display == 'block' &&
					ad.dataset.anchorStatus == "displayed"
				){
					topAdIsVisible = true;
				}

			});

			if( topAdIsVisible ) {
				toggle.style.top = `calc(1.125rem + 90px)`;
				menu.style.paddingTop = '90px';
				headerLogo.style.paddingTop = '90px';

			}else {
				toggle.style.top = '';
				menu.style.paddingTop = '';
				headerLogo.style.paddingTop = '';
			}

	}, 500);

	window.addEventListener('scroll', function(){
		//console.log(e);
		if( toggled ) {

			if(this.scrollX > 0) {
				toggled = false;
				container.classList.toggle('toggled');
				wrapper.classList.toggle('allWrapper_slideout');
			}
		}
	});

	dropdowns = [ ... container.getElementsByClassName('menu-item-has-children') ];

	if( dropdowns.length ) {
		dropdowns.forEach( ( el ) => { 

			el.querySelector('a').addEventListener('click', (e) => {
				e.stopPropagation();
			});

			el.addEventListener('click', function (e) {

				if (!window.matchMedia("(min-width: 992px)").matches) {
					//e.preventDefault();
					//e.stopPropagation();
					let dropdownList = this.querySelector('ul');

					dropdowns.forEach( ( el ) => {
						if(el != this) {
							el.classList.remove( 'toggled' );
							el.querySelector('ul').style = '';
						}

					});

					//if( !this.classList.contains( 'toggled') ) {
					//	dropdownList.style.height = dropdownList.scrollHeight+'px';
					//} else {
					//	this.querySelector('ul').style = '';
					//}
					this.classList.toggle( 'toggled' );
				}

			});
		});
	}

}



// WEBPACK FOOTER //
// ./js/src/navigation.js